<template>
  <b-modal
    id="warning-modal"
    ref="warningModal"
    :title="warningTitle"
    :class="{
      'no-title': !warningTitle,
    }"
    @hide="resolveWarning"
    v-model="toggleWarning"
    hide-footer>
    <div v-html="warningMsg"></div>

    <div class="mt-3 d-flex justify-content-end">
      <b-button
        type="button"
        variant="success"
        @click="$refs.warningModal.hide();">
        OK
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'WarningDialog',
  data() {
    return {
      warningTitle: '',
      warningMsg: '',
      toggleWarning: false,
    };
  },
  methods: {
    resolveWarning() {
      this.toggleWarning = false;
      this.warningTitle = '';
      this.warningMsg = '';
      this.$root.$emit('hide-warning');
    },
  },
  created() {
    this.$root.$on('show-warning', (data) => {
      this.toggleWarning = true;
      this.warningTitle = data.title;
      this.warningMsg = data.msg;
    });
  },
};
</script>

<style lang="scss">
.no-title {
  .modal {
    .modal-header {
      padding-top: .25rem;
      padding-bottom: .35rem;
      padding-right: .4rem;
    }
  }
}
</style>
